angular.module("app").factory("httpHandler", [
    'userStorage',
    'settingsService',
    '$location',
    '$rootScope',
    '$timeout',
    function (userStorage, settingsService, $location, $rootScope, $timeout) {
        var depricated = false;
        return {
            request: function (request) {
                request.headers['X-User'] = '*';
                if (request.url.search("views") === 0 && request.url.indexOf(".html") != -1) {
                    request.url += '?version=' + new Date().getTime()
                }
                if (request.method === 'POST') {
                    request.headers = request.headers || {};
                    var t = localStorage.getItem("t");
                    if (t) {
                        request.headers.CSRF  = t;
                    }
                }
                depricated = false;
                return request
            },
            response : function (response) {
                if (!depricated && response && response.data && (response.data.logout || (response.data.error && response.data.error.logout))) {
                    depricated = true;
                    //userStorage.resetUserData();
                 //   settingsService.reset();
                    $rootScope.$broadcast("force:logout");
                    $timeout(function () {
                        window.localStorage.removeItem("t");
                        window.location.href = "/user/logout";
                    }, 500);

                }
                return response
            }
        };
    }
]).config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('httpHandler');
}]);
